import { useContext } from "react";

import { SuiQueryContext } from "./SuiQueryContext";

export const useSuiQueryContext = () => {
  const context = useContext(SuiQueryContext);

  if (context === undefined) {
    throw new Error("useSuiQueryContext must be used within a SuiQueryContext");
  }

  return context;
};
